import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_4";
import BlockPrincipal from "../components/block/Block_5";
import BlockSecondary from "../components/block/Block_8";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.stock?.[5]}`}
        />
        <BlockPrincipal
          title={'a little about us'}
          text={rpdata?.dbAbout?.[0]?.text}
          image={rpdata?.stock?.[10]}
          image1={rpdata?.stock?.[6]}
          image3={rpdata?.stock?.[17]}
          corte={rpdata?.stock}
          listsAbout
        />
        <ValuesOne
          image={rpdata?.stock?.[5]}
          image1={rpdata?.stock?.[4]}
          image2={rpdata?.stock?.[9]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[4]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.stock?.[1]}
          image1={rpdata?.stock?.[0]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
